function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg viewBox="0 0 74 74" xmlns="http://www.w3.org/2000/svg" {...props}><g fill="none" fillRule="evenodd"><path d="M37 74c20.435 0 37-16.565 37-37S57.435 0 37 0 0 16.565 0 37s16.565 37 37 37" fill="url(#szLogoGradient)" /><path fill="#fff" d="M23.831 55.699H19.1L40.3 36.07 21.755 15.91H54.76v3.531H30.27l14.426 16.625-16.323 15.807h27.326v3.822z" /></g></svg>;
});